import { Component, } from '@angular/core';

import { NoDataFoundComponent } from '../../../shared/components/no-data-found/no-data-found.component';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../../core/components/base.component';
import { ButtonComponent } from '../../../shared/forms/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'epmax-error',
    imports: [NoDataFoundComponent, RouterModule, ButtonComponent, TranslateModule],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent extends BaseComponent {

    record: any = { title: 'Labels.NoResultsFound', message: 'Validation.YouDonotHavePermission',statusCode:'404' }
 
 
  constructor() {
    super();

    this._route.params.subscribe((res) => {
        
      this.record = {...this.record,...res};
      
    })

  }

  protected override ngSuperOnInit() {
   
  }
  
  senToSupportTeam():void{
      const supportUrlEmails = this._appData.configurations.supportTeam;
      window.location.href = 'mailto:'+ supportUrlEmails;
  }

  goBack():void{
    this._router.navigateByUrl('/main')
  }

  protected override ngSuperAfterViewInit() {
  }
  protected override ngSuperOnDestroy() {
  }

}
